import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PinterestOutlinedSvg from "@ant-design/icons-svg/es/asn/PinterestOutlined";
import AntdIcon from "../components/AntdIcon";
var PinterestOutlined = function PinterestOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PinterestOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PinterestOutlined.displayName = 'PinterestOutlined';
}
export default /*#__PURE__*/React.forwardRef(PinterestOutlined);